import Vue from 'vue'
import { Button, Table, Radio, Checkbox, Input, Spin, Tabs, Form, message, Modal, Pagination } from 'ant-design-vue'
import '@/components/l8-icon'
import './config'
import './index.less'

Vue.config.productionTip = false

Vue.use(Button)
Vue.use(Table)
Vue.use(Form)
Vue.use(Radio)
Vue.use(Checkbox)
Vue.use(Input)
Vue.use(Tabs)
Vue.use(Pagination)
Vue.use(Spin)
Vue.use(Modal)

Vue.prototype.$message = message
Vue.prototype.$modal = Modal
